export default __webpack_public_path__ + "static/media/loan_repay_12months.8c1cf9c2.png";